import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../../core';

@Injectable({
  providedIn: 'root'
})
export class CentralConfiguracoesGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.authService.podeAcessarCentralConfiguracoes()) {
      return true;
    }

    this.router.navigate(['/acesso-negado']);
    return false;
  }
}
